// extracted by mini-css-extract-plugin
export default {"header":"styles_header__sB2+9","item-number":"styles_item-number__tr+ni"};